import { jsxs, jsx, Fragment } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import useIsHovering from "../../../hooks/use-is-hovering.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import { useMemo, useCallback } from "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { AngleRightSmallOutlined as C } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/angle-right-small-outlined.es.es.js";
import { PenOutlined as i } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/pen-outlined.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { ProfileQuestionnaireStatus } from "../enums/profile-questionnaire-status.enum.es.js";
import { ProfileQuestionnaireIcon } from "./profile-questionnaire-icon.es.js";
import { ProfileQuestionnaireItemWrapper } from "./profile-questionnaire-item-wrapper.es.js";
import { ProfileQuestionnairePaper } from "./profile-questionnaire-paper.es.js";
import { Tooltip } from "../../tooltip/tooltip.es.js";
import Divider from "../../../../node_modules/@mui/material/Divider/Divider.es.js";
import Box from "../../../../node_modules/@mui/system/esm/Box/Box.es.js";
import { LinearProgress } from "../../linear-progress/linear-progress.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Typography } from "../../typography/typography.es.js";
import { Text, Success, Secondary, Border } from "../../../foundations/palette.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { Button } from "../../button/button.es.js";
import { IconButton } from "../../icon-button/icon-button.es.js";
const MAX_PERCENTAGE = 100;
const EMPTY_STRING = "";
const PROFILE_QUESTIONNAIRE_TITLE_SPACING_SIZE = "1.9375rem";
function ProfileQuestionnaireItem({
  id,
  activeIcon,
  inactiveIcon,
  percentage,
  sectionNumber,
  title,
  fallbackDescription,
  status,
  isMobile = false,
  buttonText = "button text",
  percentagePrefixText = "percentage prefix text",
  withLinearProgress = false,
  withBottomDivider = true,
  onClick,
  onClickEndActionButton,
  editButtonTooltipText = "",
  tooltipOpen = false,
  itemTooltipMessage
}) {
  const {
    isHovering,
    startHover,
    endHover
  } = useIsHovering();
  const isSectionActive = useMemo(function getSectionActive() {
    return status === ProfileQuestionnaireStatus.Completing;
  }, [status]);
  const isSectionCompleted = useMemo(function getSectionCompleted() {
    return percentage === MAX_PERCENTAGE;
  }, [percentage]);
  const description = useMemo(function getDescription() {
    if (isSectionCompleted)
      return EMPTY_STRING;
    if (status === ProfileQuestionnaireStatus.Completing)
      return `${percentagePrefixText} ${percentage}%`;
    return fallbackDescription;
  }, [isSectionCompleted, status]);
  const shouldUseGrayText = useMemo(function memoizeShouldUseGrayText() {
    return isSectionActive || isSectionCompleted;
  }, [isSectionActive, isSectionCompleted]);
  const shouldShowTooltipMessage = useMemo(function memoizeShouldShowTooltipMessage() {
    return itemTooltipMessage && itemTooltipMessage !== "";
  }, [itemTooltipMessage]);
  const shouldShowEditButtonTooltip = useMemo(function memoizeShouldShowEditButton() {
    return editButtonTooltipText !== "";
  }, []);
  const titleVariant = isMobile ? "subtitle1" : "h6";
  const descriptionVariant = isMobile ? "caption" : "body1";
  const onClickBoxCallback = useCallback(function onClickBox() {
    if (isSectionCompleted)
      return onClick == null ? void 0 : onClick(id);
    if (isSectionActive)
      return onClickEndActionButton == null ? void 0 : onClickEndActionButton(id);
  }, [isSectionCompleted, isSectionActive, onClick, onClickEndActionButton]);
  const profileQuestionnaireItem = /* @__PURE__ */ jsxs(Box, { onMouseEnter: startHover, onMouseLeave: endHover, onClick: onClickBoxCallback, style: {
    cursor: isSectionActive || isSectionCompleted ? "pointer" : "initial"
  }, children: [
    withLinearProgress ? /* @__PURE__ */ jsx(LinearProgress, { value: percentage, color: "secondary", variant: "determinate" }) : /* @__PURE__ */ jsx(Fragment, {}),
    /* @__PURE__ */ jsx(ProfileQuestionnairePaper, { elevation: 0, isMobile, isActive: isSectionActive, children: /* @__PURE__ */ jsxs(ProfileQuestionnaireItemWrapper, { isMobile, isActive: isSectionActive, children: [
      /* @__PURE__ */ jsx(ProfileQuestionnaireIcon, { isMobile, isSectionCompleted, isSectionActive, activeIcon, inactiveIcon }),
      /* @__PURE__ */ jsxs("div", { style: {
        display: isMobile ? Displaying.initial : Displaying.inherit,
        width: "100%"
      }, children: [
        /* @__PURE__ */ jsxs("div", { style: {
          display: Displaying.flex
        }, children: [
          /* @__PURE__ */ jsxs("div", { style: {
            minWidth: PROFILE_QUESTIONNAIRE_TITLE_SPACING_SIZE
          }, children: [
            /* @__PURE__ */ jsx(Typography, { color: shouldUseGrayText ? Text.primary : Text.secondary, variant: titleVariant, children: sectionNumber }),
            /* @__PURE__ */ jsx(Typography, { color: Text.secondary, variant: titleVariant, style: {
              marginLeft: Spacing["500"],
              marginRight: Spacing["500"]
            }, children: "·" })
          ] }),
          /* @__PURE__ */ jsx("div", { style: {
            marginRight: Spacing["500"]
          }, children: /* @__PURE__ */ jsx(Typography, { color: shouldUseGrayText ? Text.primary : Text.secondary, variant: titleVariant, children: title }) })
        ] }),
        /* @__PURE__ */ jsx("div", { style: {
          flexGrow: 1,
          marginLeft: isMobile ? PROFILE_QUESTIONNAIRE_TITLE_SPACING_SIZE : 0
        }, children: /* @__PURE__ */ jsx(Typography, { color: isSectionActive ? Success.main : Text.secondary, variant: descriptionVariant, children: description }) }),
        isSectionActive ? /* @__PURE__ */ jsx("div", { style: {
          marginLeft: isMobile ? Spacing["1500"] : 0,
          marginTop: isMobile ? Spacing["750"] : "initial"
        }, children: /* @__PURE__ */ jsx(Button, { variant: "contained", color: "success", size: "medium", endIcon: /* @__PURE__ */ jsx(C, {}), onClick: () => onClickEndActionButton == null ? void 0 : onClickEndActionButton(id), children: buttonText }) }) : /* @__PURE__ */ jsx(Fragment, {})
      ] }),
      isSectionCompleted ? /* @__PURE__ */ jsx(Tooltip, { description: editButtonTooltipText, disableHoverListener: !shouldShowEditButtonTooltip, disableTouchListener: !shouldShowEditButtonTooltip, children: /* @__PURE__ */ jsx(IconButton, { size: "small", onClick: (e) => {
        e.stopPropagation();
        onClick == null ? void 0 : onClick(id);
      }, style: {
        opacity: isHovering || isMobile ? 1 : 0,
        transition: "all .1s"
      }, children: /* @__PURE__ */ jsx(i, { color: "primary" }) }) }) : /* @__PURE__ */ jsx(Fragment, {})
    ] }) }),
    withBottomDivider ? /* @__PURE__ */ jsx(Divider, { style: {
      borderColor: isSectionActive ? Secondary.main : Border.main
    } }) : /* @__PURE__ */ jsx(Fragment, {})
  ] });
  return shouldShowTooltipMessage ? /* @__PURE__ */ jsx(Tooltip, { open: tooltipOpen, description: itemTooltipMessage ?? "", arrow: true, placement: "top", children: profileQuestionnaireItem }) : profileQuestionnaireItem;
}
export {
  ProfileQuestionnaireItem
};
//# sourceMappingURL=profile-questionnaire-item.es.js.map
